import { GenericActions } from "../../redux/generic-actions";
import { componentsReducer } from "../../redux/root.reducer";

export function commonStatefulContainerReducerFactory(rootProp, initialState) {
    return function commonDatalistReducer(state = initialState, action) {
        const stateProp: string = action.stateProp;
        state = componentsReducer(rootProp, state, action);

        switch (action.type) {
            case `${rootProp}::${GenericActions.DETAIL_LOADED}`:
                return state.setIn([stateProp, "value"], action.payload);
            case `${rootProp}::${GenericActions.STATE_RESET}`:
                return state.delete(stateProp);
            default:
                return state;
        }
    };
};
